<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Đẩy thông báo: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :model="noti" ref="createModel">
            <el-form-item prop="title" label="Tiêu đề" class="form-item">
              <el-input v-model="noti.title" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="body" label="Nôi dung" class="form-item">
              <el-input type="textarea" :rows="5" v-model="noti.body" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Đẩy thông báo</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'UserUpdate',
  metaInfo () {
    return {
      title: 'Tài khoản | Đẩy thông báo'
    }
  },
  components: {

  },
  data () {
    return {
      canSubmit: true,
      noti: {
        title: '',
        body: ''
      },
      modelData: {
        name: '',
        email: '',
        phone: '',
        avatar: '',
        avatar_path: '',
        password: '',
        password_confirmation: '',
        address: '',
        birthday: '',
        sex: 1,
        user_type: '',
        user_content: '',
        status: true
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'users-index', text: 'Tài khoản' },
        { name: 'users-create', text: 'Đẩy thông báo' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'users-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('users/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('users/push-noti/' + this.$route.params.id, this.noti).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Đẩy thông báo thành công',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
.course {
  width: 200px;
  height: 200px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/users/PushNoti.vue